import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCL7mTVaZ9kcP3gOrVPPyPkoOyvePHltF4',
    }
});
